export default "__VITE_ASSET__ADYzKI45__"